export const getApplicationName = (applicationId) => applicationId.replace(/-\d+(\.\d+)*.*/, '');
